import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { StorageService } from '@services/storage.service';

export interface INotRespond {code: string; parent_id: string}

@Injectable({
  providedIn: 'root',
})
export class ServerNotRespondingService {
  private hasError = new BehaviorSubject<INotRespond | null>(null) ;
  hasError$: Observable<INotRespond | null>;

  constructor(private storage: StorageService) {
    this.hasError = new BehaviorSubject<INotRespond | null>(
      this.storage.get('server-not-responding', null)
    );
    this.hasError$ = this.hasError.asObservable()
  }

  hasErrorSnapshot() {
    return this.hasError.value;
  }

  enableFullscreenError(errorData: INotRespond) {
    this.hasError.next(errorData);
    this.storage.set('server-not-responding', errorData);
  }

  disableFullscreenError() {
    this.hasError.next(null);
    this.storage.set('server-not-responding', null);
  }
}
